/**
* VC Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the VC Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'vc-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {

    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'vc-callout', COMPONENT );
} )( app );
